import { diff, isBefore, isSame } from './time';
export const eventLengthInDays = ({
  start,
  end
}) => diff(end, start, 'days') + 1;
export const isSameDayEvent = ({
  start,
  end,
  timezone
}) => isSame(start, end, timezone, 'day');
export const doesEventStartBeforeDay = ({
  start,
  time,
  timezone
}) => isBefore(start, time, timezone, 'day');